"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NETWORK_CONNECT_TIMEOUT_ERROR = exports.SERVICE_UNAVAILABLE_STATUS = exports.SERVEUR_ERROR_STATUS = exports.RETRY_WITH_STATUS = exports.TOO_MANY_REQUEST_STATUS = exports.PRECONDITION_FAILED_STATUS = exports.GONE_STATUS = exports.CONFLICT_STATUS = exports.NOT_FOUND_STATUS = exports.PRECONDITION_REQUIRED_STATUS = exports.FORBIDDEN_STATUS = exports.UNAUTHORIZED_STATUS = exports.BAD_REQUEST_STATUS = exports.TEMPORARY_REDIRECT = exports.FOUND_STATUS = exports.PARTIAL_CONTENT_STATUS = exports.NO_CONTENT_STATUS = exports.SUCCESS_STATUS = void 0;
exports.SUCCESS_STATUS = 200;
exports.NO_CONTENT_STATUS = 204;
exports.PARTIAL_CONTENT_STATUS = 206;
exports.FOUND_STATUS = 302;
exports.TEMPORARY_REDIRECT = 307;
exports.BAD_REQUEST_STATUS = 400;
exports.UNAUTHORIZED_STATUS = 401;
exports.FORBIDDEN_STATUS = 403;
exports.PRECONDITION_REQUIRED_STATUS = 428;
exports.NOT_FOUND_STATUS = 404;
exports.CONFLICT_STATUS = 409;
exports.GONE_STATUS = 410;
exports.PRECONDITION_FAILED_STATUS = 412;
exports.TOO_MANY_REQUEST_STATUS = 429;
exports.RETRY_WITH_STATUS = 449;
exports.SERVEUR_ERROR_STATUS = 500;
exports.SERVICE_UNAVAILABLE_STATUS = 503;
exports.NETWORK_CONNECT_TIMEOUT_ERROR = 599;
